import { type GenericFiltersMap, mapFilterOption } from "../../../../../../utils/filterUtils";
import dataService from "../../../../../Application/services/dataServices/typedDataService";
import * as actionTypes from "../actionTypes/emailDetailsActionTypes";
import { getActionBaseProvider, getActionProvider } from "../../../../../Application/actions/actionsBuilder";
import {
  type EmailView,
  type Template,
  type Email,
  type LoadTemplateResult,
  type EmailTagsPayload,
} from "../../types/state";
import { type Dispatcher } from "../../../../../../interfaces/redux";
import { setEmailEntityId } from "../actionTypes/emailEntityStateActionTypes";
import { batch } from "react-redux";
import { type CancelTokenSource } from "axios";
import objUtils from "../../../../../../utils/objectUtils";
import { TagsEnum } from "../../../../../../interfaces/TagsEnum";
import { type Tag } from "../../../../../../interfaces/Tag";
import { uniqBy } from "lodash";

export const saveEmail = (emailMetadata: EmailView) => {
  const saveEmailAction = getActionProvider<EmailView>(actionTypes.saveEmail);

  return (dispatch: Dispatcher) => {
    dispatch(saveEmailAction(emailMetadata));
  };
};

export const saveTemplate = (emailTemplate: Template) => {
  const saveEmailAction = getActionProvider<Template>(actionTypes.saveEmailTemplate);

  return (dispatch: Dispatcher) => {
    dispatch(saveEmailAction(emailTemplate));
  };
};

export const clearEmail = () => {
  const resetEmailAction = getActionBaseProvider(actionTypes.clearEmail);

  return (dispatch: Dispatcher) => {
    dispatch(resetEmailAction());
  };
};

export const getEmail = (id: number, cancelTokenSource?: CancelTokenSource) => {
  const begin = getActionBaseProvider(actionTypes.getEmailBegin);
  const success = getActionProvider<Email>(actionTypes.getEmailSuccess);
  const failure = getActionProvider<Error>(actionTypes.getEmailFailure);

  return (dispatch: Function) => {
    dispatch(begin());
    dataService.emails
      .getEmailAsync(id, cancelTokenSource?.token)
      .then((result: any) => {
        batch(() => {
          dispatch(success(result.data));
          dispatch(setEmailEntityIdAction(result.data.id || 0));
        });
      })
      .catch((error: Error) => dispatch(failure(error)));
  };
};
export const getEmailTemplate = (id: number, getTemplateOnly: boolean = false) => {
  const begin = getActionBaseProvider(actionTypes.getEmailTemplateBegin);
  const success = getActionProvider<LoadTemplateResult>(actionTypes.getEmailTemplateSuccess);
  const failure = getActionProvider<Error>(actionTypes.getEmailTemplateFailure);

  return async (dispatch: Function) => {
    dispatch(begin());
    dataService.emails
      .getEmailTemplateAsync(id)
      .then((result: any) => dispatch(success({ template: result.data, getTemplateOnly })))
      .catch((error: Error) => dispatch(failure(error)));
  };
};

export const fetchTags = () => {
  const success = getActionProvider<EmailTagsPayload>(actionTypes.fetchTagsSuccess);
  const failure = getActionProvider<Error>(actionTypes.fetchTagsFailure);

  const tagToFilterMap: { [key in TagsEnum]?: TagsEnum } = {
    [TagsEnum.Label]: TagsEnum.Label,
    [TagsEnum.SoftwareApplication]: TagsEnum.SoftwareApplication,
    [TagsEnum.SkuVersion]: TagsEnum.SkuVersion,
  };

  const readTagsData = (tags: EmailTagsPayload) => {
    let filterOptions: GenericFiltersMap<TagsEnum> = {
      Label: [],
      SoftwareApplication: [],
      SkuVersion: [],
    };

    for (let [key, value] of objUtils.typedEntries<TagsEnum, Tag[]>(tags)) {
      if (tagToFilterMap[key] && Array.isArray(value) && value.length > 0) {
        filterOptions = mapFilterOption(filterOptions, value, tagToFilterMap[key], (item: Tag) => ({
          id: item.id,
          title: item.title,
        }));
        filterOptions[tagToFilterMap[key]] = uniqBy(filterOptions[tagToFilterMap[key]], "title");
      }
    }
    return filterOptions;
  };

  return async (dispatch: Function) => {
    dataService.emails
      .getTags(true)
      .then((result: { data: EmailTagsPayload }) => dispatch(success(readTagsData(result.data))))
      .catch((error: Error) => dispatch(failure(error)));
  };
};

export const setEmailAction = getActionProvider<Email>(actionTypes.setEmail);

export const setEmailEntityIdAction = getActionProvider<number>(setEmailEntityId);
